import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Article } from '../shared/models/article.model';
import { BoardService } from "../shared/services/board/board.service";
import {api_url_replace} from "../shared/defines/protocol";

const BOARD_ADMIN_MSG = 1;
const BOARD_ADMIN_FIXED = 2;

@Component({
  selector: 'app-admin-msg',
  templateUrl: './admin-msg.component.html',
  styleUrls: ['./admin-msg.component.scss']
})
export class AdminMsgComponent implements OnInit, OnDestroy {

  protected readonly ApiUrlReplace = api_url_replace;

  public adminMsg?: Article;
  public fixedMsg?: Article;
  private adminMsg$: Subscription | null = null;
  private fixedMsg$: Subscription | null = null;

  private isLoadingAdmin: boolean = false;
  private isLoadingFixed: boolean = false;
  get is_loading(): boolean {
    return this.isLoadingAdmin || this.isLoadingFixed;
  }

  constructor(
    private boardSvc: BoardService,
  ) {
  }

  ngOnInit() {
    this.loadArticle();
    this.loadFixedMsg();
  }

  ngOnDestroy() {
    if (this.adminMsg$) {
      this.adminMsg$.unsubscribe();
      this.adminMsg$ = null;
    }
    if (this.fixedMsg$) {
      this.fixedMsg$.unsubscribe();
      this.fixedMsg$ = null;
    }
  }

  private loadArticle(): void {
    if (this.adminMsg$) {
      this.adminMsg$.unsubscribe();
      this.adminMsg$ = null;
    }
    this.isLoadingAdmin = true;
    this.adminMsg$ = this.boardSvc.GetDetail(BOARD_ADMIN_MSG).pipe(
      finalize(() => {
        this.adminMsg$ = null;
        this.isLoadingAdmin = false;
      }),
    ).subscribe(
      article => {
        this.adminMsg = new Article(article);
      }
    );
  }

  private loadFixedMsg(): void {
    if (this.fixedMsg$) {
      this.fixedMsg$.unsubscribe();
      this.fixedMsg$ = null;
    }
    this.isLoadingFixed = true;
    this.fixedMsg$ = this.boardSvc.GetDetail(BOARD_ADMIN_FIXED).pipe(
      finalize(() => {
        this.fixedMsg$ = null;
        this.isLoadingFixed = false;
      }),
    ).subscribe(
      fixedMsg => {
        this.fixedMsg = new Article(fixedMsg);
      }
    );
  }
}
